import {useEffect,useState} from 'react';
import {getApiUrl} from '../config/serverEndpoint';
import {accountHeaders} from './accountFetch';
export default function useWheelStatus(username,open){
 const [snapshot,setSnapshot]=useState(null);
 useEffect(()=>{
  let alive=true,controller,timer;
  const refresh=async()=>{
   controller?.abort();clearTimeout(timer);const request=new AbortController();controller=request;
   try{const response=await fetch(getApiUrl(`/wheel?username=${encodeURIComponent(username)}`),{headers:accountHeaders(),cache:'no-store',signal:request.signal});const value=await response.json();if(!response.ok)throw Error('wheel unavailable');if(!alive||request.signal.aborted)return;
    setSnapshot({owner:username,value});const delay=Number(value.nextAt)-Date.now();if(delay>0)timer=setTimeout(refresh,Math.min(delay+250,2147483647));
   }catch(_){if(alive&&!request.signal.aborted)setSnapshot({owner:username,value:null});}
  };
  const visible=()=>{if(document.visibilityState!=='hidden')refresh();};
  refresh();window.addEventListener('focus',refresh);window.addEventListener('online',refresh);window.addEventListener('kelimo-coins-updated',refresh);document.addEventListener('visibilitychange',visible);
  return()=>{alive=false;controller?.abort();clearTimeout(timer);window.removeEventListener('focus',refresh);window.removeEventListener('online',refresh);window.removeEventListener('kelimo-coins-updated',refresh);document.removeEventListener('visibilitychange',visible);};
 },[username,open]);
 return snapshot?.owner===username?snapshot.value:null;
}
